import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Nav from "../../components/Navbar/Nav";
import Row from "../../components/Movies/Row";
import apiUrl from "../../api/config.json";
import axios from "../../api/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faBirthdayCake, faStar, faVenusMars } from "@fortawesome/free-solid-svg-icons";
import "./Actor.css";

function Actor() {
	const { id } = useParams();
	const actorId = id;

	const [actor, setActor] = useState([]);
	const [popular, setPopular] = useState("");
	const [images, setImages] = useState([]);

	const API_KEY = apiUrl.APIKey;
	const base_url = "https://image.tmdb.org/t/p/original";

	const actorRequest = `/person/${actorId}?api_key=${API_KEY}&language=en-US`;
	const getPopular = `/person/${actorId}/combined_credits?api_key=${API_KEY}&num_votes=2000&language=en-US&sort=user_rating`;
	const getImages = `/person/${actorId}/tagged_images?api_key=${API_KEY}&language=en-US&page=1`;

	useEffect(() => {
		async function getActor() {
			try {
				let request = await axios.get(actorRequest);
				setActor(request.data);
				return request;
			} catch (err) {
				console.log(err.response, "No Actor found?");
			}
		}
		getActor();

		async function getMovies() {
			try {
				let request = await axios.get(getPopular);
				setPopular(getPopular);
				return request;
			} catch (err) {
				console.log(err.response);
			}
		}
		getMovies();

		async function getGallery() {
			try {
				let request = await axios.get(getImages);
				setImages(request.data.results);
				return request;
			} catch (err) {
				console.log(err.response);
			}
		}
		getGallery();
	}, [actorRequest, getPopular, getImages]);

	const today = new Date();
	const birthDate = new Date(actor.birthday);
	const age = today.getYear() - birthDate.getYear();

	return (
		<div>
			<Nav />
			<div className="actor-page">
				{/* Sidebar */}
				<aside className="actor-sidebar">
					<div className="actor-sidebar__photo">
						<img
							src={`${base_url}${actor.profile_path}`}
							alt={actor?.name}
						/>
					</div>

					<h2 className="actor-sidebar__name">{actor?.name}</h2>

					<div className="actor-sidebar__info-group">
						<div className="actor-info-item">
							<FontAwesomeIcon icon={faStar} className="actor-info-item__icon" />
							<div>
								<span className="actor-info-item__label">Known For</span>
								<span className="actor-info-item__value">
									{actor?.known_for_department}
								</span>
							</div>
						</div>

						<div className="actor-info-item">
							<FontAwesomeIcon icon={faVenusMars} className="actor-info-item__icon" />
							<div>
								<span className="actor-info-item__label">Gender</span>
								<span className="actor-info-item__value">
									{actor?.gender === 1 ? "Female" : "Male"}
								</span>
							</div>
						</div>

						<div className="actor-info-item">
							<FontAwesomeIcon icon={faBirthdayCake} className="actor-info-item__icon" />
							<div>
								<span className="actor-info-item__label">Birthday</span>
								<span className="actor-info-item__value">
									{actor?.birthday} ({age} years old)
								</span>
							</div>
						</div>

						<div className="actor-info-item">
							<FontAwesomeIcon icon={faLocationDot} className="actor-info-item__icon" />
							<div>
								<span className="actor-info-item__label">Birthplace</span>
								<span className="actor-info-item__value">
									{actor?.place_of_birth}
								</span>
							</div>
						</div>

						{actor.also_known_as?.length > 0 && (
							<div className="actor-info-item">
								<span className="actor-info-item__label">Also Known As</span>
								<div className="actor-info-item__tags">
									{actor.also_known_as.slice(0, 5).map((name) => (
										<span key={name} className="actor-info-item__tag">
											{name}
										</span>
									))}
								</div>
							</div>
						)}
					</div>
				</aside>

				{/* Main Content */}
				<main className="actor-main">
					<h1 className="actor-main__name">{actor?.name}</h1>

					{actor?.biography && (
						<section className="actor-main__bio">
							<h3 className="actor-main__section-title">Biography</h3>
							<p className="actor-main__bio-text">{actor?.biography}</p>
						</section>
					)}

					{images?.length > 0 && (
						<section className="actor-main__gallery">
							<h3 className="actor-main__section-title">Photos</h3>
							<div className="actor-gallery">
								{images.slice(0, 10).map((image, idx) => (
									<div key={idx} className="actor-gallery__item">
										<img
											src={`${base_url}${image?.file_path}`}
											alt=""
										/>
									</div>
								))}
							</div>
						</section>
					)}

					<Row title="Known For" fetchUrl={popular} isLargeRow />
				</main>
			</div>
		</div>
	);
}

export default Actor;
